<template>
    <div id="room-wrapper">
        <h1 class="title is-1">{{title}}</h1>
        <component :is="roomView"></component>
    </div>
</template>

<script>
import Generic from './rooms/Generic'
import GenericImage from './rooms/GenericImage'
import StartPortal from './rooms/StartPortal'
// @todo write SoundOnlyComponent
export default {
  name: 'RoomWrapper',
  data () {
    return {
      component: {
        Portratt: 'GenericImage',
        Kansla: 'GenericImage',
        Platsvaggen: 'GenericImage',
        Kulisser: 'GenericImage',
        Problem: 'GenericImage',
        StartPortal: 'StartPortal'
      }
    }
  },
  computed: {
    roomView: function () {
      const title = this.title.replace('ä', 'a').replace('å', 'a').replace('ö', 'o')
      if (this.component[title]) {
        return this.component[title]
      }
      if (this.$options.components[title]) {
        return title
      }
      return 'Generic'
    },
    title: function () {
      return this.$route.params.title
    }
  },
  components: { Generic, GenericImage, StartPortal },
  methods: {
    log: function (item) {
      console.log(item)
    }
  }
}
</script>
